import loopback from './loopback'

// Cliente fino do Dashboard: as agregações são feitas no backend (zero cálculo no front).
// refreshDataFromAPI faz UMA chamada ao endpoint agregado e armazena o payload pronto;
// os métodos abaixo apenas fatiam esse payload para cada componente.

const EMPTY_STATS = {
  kpis: { totalCalls: 0, answeredCalls: 0, talkTimeSeconds: 0 },
  hangupcause: { labels: [], hangups: {} },
  byExtension: {},
  overallPatience: 0,
  series: {}
}

const EMPTY_SERIES = { labels: [], extensions: {}, calls: {} }

const CDRDataSource = {}

CDRDataSource.stats = EMPTY_STATS

// Monta a query string do endpoint a partir do filtro montado pelo Dashboard.
function buildQuery (filter) {
  const params = []
  if (filter.startedAt) params.push('startedAt=' + encodeURIComponent(filter.startedAt))
  if (filter.endedAt) params.push('endedAt=' + encodeURIComponent(filter.endedAt))
  if (filter.callType) params.push('callType=' + encodeURIComponent(filter.callType))
  if (filter.filterUsers && filter.filterUsers.length > 0) {
    params.push('users=' + encodeURIComponent(JSON.stringify(filter.filterUsers)))
  }
  if (filter.filterHangupCause && filter.filterHangupCause.length > 0) {
    params.push('hangupCauses=' + encodeURIComponent(JSON.stringify(filter.filterHangupCause)))
  }
  return params.length > 0 ? `?${params.join('&')}` : ''
}

function fetchStatistics (filter) {
  return loopback
    .get(`/calls/dashboard-statistics${buildQuery(filter || {})}`)
    .then(stats => {
      CDRDataSource.stats = stats || EMPTY_STATS
      return undefined
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

CDRDataSource.initialize = (filter) => fetchStatistics(filter)
CDRDataSource.refreshDataFromAPI = (filter) => fetchStatistics(filter)

// KPIs: o Dashboard soma os valores; devolvemos os totais já prontos do backend.
CDRDataSource.callStatistics = () => {
  const kpis = CDRDataSource.stats.kpis || EMPTY_STATS.kpis
  return Promise.resolve({
    calls: { total: kpis.totalCalls },
    answers: { total: kpis.answeredCalls },
    durations: { total: kpis.talkTimeSeconds }
  })
}

// Donut: distribuição por status (rótulos traduzidos já vêm do backend).
CDRDataSource.hangupcauseStatistics = () => {
  const hangupcause = CDRDataSource.stats.hangupcause || EMPTY_STATS.hangupcause
  return Promise.resolve({ labels: hangupcause.labels, hangups: hangupcause.hangups })
}

// Série "Chamadas por usuário" da granularidade pedida (o backend devolve todas).
CDRDataSource.extensionStatistics = (granularity = 'hora') => {
  const series = CDRDataSource.stats.series || {}
  return Promise.resolve(series[granularity] || EMPTY_SERIES)
}

// Paciência (mediana) + agregados por usuário para a tabela "Desempenho por usuário".
CDRDataSource.patienceStatistics = () => {
  return Promise.resolve({
    overall: CDRDataSource.stats.overallPatience || 0,
    byExtension: CDRDataSource.stats.byExtension || {}
  })
}

// Opções do filtro de Usuários: usuários ATIVOS (com ramal) da organização, via /users —
// mesma fonte da tela de Usuários. A busca por nome vai para o servidor (TEL-2226: filtrar só
// o que já estava carregado não achava quem ficava nas páginas seguintes). Paginado (infinite
// scroll) para escalar sem truncar.
// Retorna { options, hasMore } — hasMore=true quando a página veio cheia (pode ter mais).
// Erro é propagado: o Dashboard mostra o aviso e permite tentar de novo.
CDRDataSource.userOptions = (skip = 0, limit = 100, name = '') => {
  // status ausente/desconhecido conta como ativo (igual ao getUserStatus da tela de Usuários).
  // Fica no front de propósito: o ADMIN criado no cadastro da conta nasce com status nulo,
  // e um where por status no servidor (como o do /users/team) o esconderia do filtro.
  const isActive = (user) => {
    const raw = user && user.status != null
      ? String(user.status).trim().toUpperCase().replace(/\s+/g, '_')
      : ''
    return raw === '' || raw === 'ACTIVE'
  }
  const filter = { order: 'name ASC', limit, skip }
  if (name) filter.where = { name: { ilike: `%${name}%` } }
  return loopback.get(`/users?filter=${encodeURIComponent(JSON.stringify(filter))}`)
    .then(list => {
      if (!Array.isArray(list)) return { options: [], hasMore: false }
      const options = list
        .filter(user => isActive(user) && user.extension != null && String(user.extension).trim() !== '')
        .map(user => {
          const ext = String(user.extension).trim()
          const userName = (user.name && user.name.trim()) || ext
          return { value: ext, text: `${userName} (${ext})` }
        })
      // Página veio cheia (pelo total bruto) => provavelmente há mais.
      return { options, hasMore: list.length === limit }
    })
}

export default CDRDataSource



// WEBPACK FOOTER //
// ./src/services/cdr-data-source.js